module.exports = __webpack_public_path__ + "img/9788920007347.c13cd334.jpg";